/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_JA_JP: Record<string, string> = {
    ariaAnnounceChart: 'チャート, ${seriesCount}[number]シリーズ',
    ariaAnnounceFlowProportionLink: 'リンク ${index} / ${count}、${from} から ${to} へ、${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'ノード ${index} / ${count}、${description}',
    ariaAnnounceGaugeChart: 'ゲージチャート、${caption}',
    ariaAnnounceHierarchyChart: '階層チャート, ${caption}',
    ariaAnnounceHierarchyDatum: 'レベル ${level}[number]、${count}[number] の子供、${description}',
    ariaAnnounceHoverDatum: '${datum}にフォーカスしています',
    ariaDescriptionLegendItem: 'Space キーまたは Enter キーを押して表示を切り替えます',
    ariaLabelAddHorizontalLine: '水平線を追加',
    ariaLabelAnnotationOptionsToolbar: '注釈オプション',
    ariaLabelAnnotationSettingsDialog: '注釈設定',
    ariaLabelColorPicker: 'カラーピッカー',
    ariaLabelFinancialCharts: 'ファイナンシャルチャート',
    ariaLabelLegend: '凡例',
    ariaLabelLegendItem: '${label}, 凡例アイテム ${index}[number] / ${count}[number]',
    ariaLabelLegendItemUnknown: '不明な凡例項目',
    ariaLabelLegendPageNext: '次の凡例ページ',
    ariaLabelLegendPagePrevious: '前の凡例ページ',
    ariaLabelLegendPagination: '凡例ページネーション',
    ariaLabelNavigator: 'ナビゲーター',
    ariaLabelNavigatorMaximum: '最大',
    ariaLabelNavigatorMinimum: '最小',
    ariaLabelNavigatorRange: '範囲',
    ariaLabelRangesToolbar: '範囲',
    ariaLabelSettingsTabBar: '設定',
    ariaLabelZoomToolbar: 'ズーム',
    ariaValuePanRange: '${min}[percent0to2dp] から ${max}[percent0to2dp]',
    contextMenuDownload: 'ダウンロード',
    contextMenuPanToCursor: 'ここにパンする',
    contextMenuToggleOtherSeries: '他のシリーズを切り替える',
    contextMenuToggleSeriesVisibility: '表示を切り替える',
    contextMenuZoomToCursor: 'ここにズーム',
    dialogHeaderChannel: 'チャンネル',
    dialogHeaderDatePriceRange: '日付と価格',
    dialogHeaderDateRange: '日付範囲',
    dialogHeaderFibonacciRange: 'フィボナッチリトレースメント',
    dialogHeaderLine: 'ライン',
    dialogHeaderPriceRange: '価格範囲',
    dialogHeaderText: 'テキスト',
    dialogInputAlign: '整列',
    dialogInputColorPicker: '色',
    dialogInputColorPickerAltText: 'テキストの色',
    dialogInputExtendAbove: '上に拡張する',
    dialogInputExtendBelow: '以下に拡張',
    dialogInputExtendChannelEnd: 'チャネルの終わりを拡張する',
    dialogInputExtendChannelStart: 'チャネルの開始を延長する',
    dialogInputExtendLeft: '「左に伸ばす」',
    dialogInputExtendLineEnd: 'ライン終端を拡張する',
    dialogInputExtendLineStart: '線の開始を延長する',
    dialogInputExtendRight: '右へ拡張',
    dialogInputFibonacciBands: 'バンド',
    dialogInputFibonacciBandsAltText: 'フィボナッチバンド',
    dialogInputFillColorPicker: '塗りつぶし',
    dialogInputFillColorPickerAltText: '塗りつぶしの色',
    dialogInputFontSize: 'サイズ',
    dialogInputFontSizeAltText: 'フォントサイズ',
    dialogInputLineStyle: 'ダッシュ',
    dialogInputPosition: '位置',
    dialogInputReverse: '反転',
    dialogInputShowFill: '塗りつぶしを表示',
    dialogInputStrokeWidth: '太さ',
    dialogInputStrokeWidthAltText: '線の太さ',
    iconAltTextAlignCenter: '中央揃え',
    iconAltTextAlignLeft: '左',
    iconAltTextAlignRight: '右',
    iconAltTextClose: '閉じる',
    iconAltTextLineStyleDashed: '長い破線',
    iconAltTextLineStyleDotted: '短い破線',
    iconAltTextLineStyleSolid: '実線',
    iconAltTextPositionBottom: '下',
    iconAltTextPositionCenter: '中央',
    iconAltTextPositionTop: '「トップ」',
    inputTextareaPlaceholder: 'テキストを追加',
    measurerDateRangeBars: '${value}[number] 本のバー',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '『${value}[number]』',
    measurerVolume: 'ボリューム ${value}',
    overlayLoadingData: 'データを読み込み中...',
    overlayNoData: '表示するデータがありません',
    overlayNoVisibleSeries: '表示可能なシリーズがありません',
    overlayUnsupportedBrowser: '互換性のないブラウザーのバージョンです。ブラウザーをアップグレードしてください。',
    seriesHistogramTooltipCount: '${yName} (カウント)',
    seriesHistogramTooltipFrequency: '頻度',
    seriesHistogramTooltipMean: '${yName} (平均)',
    seriesHistogramTooltipSum: '${yName} (合計)',
    toolbarAnnotationsArrow: '矢印',
    toolbarAnnotationsArrowDown: '下向きの矢印',
    toolbarAnnotationsArrowUp: '矢印上',
    toolbarAnnotationsCallout: '図形注釈',
    toolbarAnnotationsClearAll: 'すべてクリア',
    toolbarAnnotationsComment: 'コメント',
    toolbarAnnotationsDatePriceRange: '「日付と価格」',
    toolbarAnnotationsDateRange: '日付範囲',
    toolbarAnnotationsDelete: '削除',
    toolbarAnnotationsDisjointChannel: '非連結チャネル',
    toolbarAnnotationsDragHandle: 'ツールバーをドラッグ',
    toolbarAnnotationsFibonacciAnnotations: 'フィボナッチ',
    toolbarAnnotationsFibonacciRetracement: 'フィボナッチ・リトレースメント',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'フィボナッチトレンドベース',
    toolbarAnnotationsFillColor: '塗りつぶしの色',
    toolbarAnnotationsHorizontalLine: '水平線',
    toolbarAnnotationsLineAnnotations: 'トレンドライン',
    toolbarAnnotationsLineColor: '線の色',
    toolbarAnnotationsLineStrokeWidth: '線の太さ',
    toolbarAnnotationsLineStyle: '線スタイル',
    toolbarAnnotationsLock: 'ロック',
    toolbarAnnotationsMeasurerAnnotations: '測定ツール',
    toolbarAnnotationsNote: 'ノート',
    toolbarAnnotationsParallelChannel: 'パラレルチャネル',
    toolbarAnnotationsPriceRange: '価格範囲',
    toolbarAnnotationsQuickDatePriceRange: '測定',
    toolbarAnnotationsSettings: '設定',
    toolbarAnnotationsShapeAnnotations: '矢印',
    toolbarAnnotationsText: 'テキスト',
    toolbarAnnotationsTextAnnotations: 'テキスト注釈',
    toolbarAnnotationsTextColor: 'テキストの色',
    toolbarAnnotationsTextSize: '文字サイズ',
    toolbarAnnotationsTrendLine: 'トレンドライン',
    toolbarAnnotationsUnlock: 'ロック解除',
    toolbarAnnotationsVerticalLine: '垂直線',
    toolbarRange1Month: '1ヶ月',
    toolbarRange1MonthAria: '1か月',
    toolbarRange1Year: '1年',
    toolbarRange1YearAria: '1年',
    toolbarRange3Months: '3ヶ月',
    toolbarRange3MonthsAria: '3ヶ月',
    toolbarRange6Months: '6ヶ月',
    toolbarRange6MonthsAria: '6か月',
    toolbarRangeAll: 'すべて',
    toolbarRangeAllAria: 'すべて',
    toolbarRangeYearToDate: '年初来',
    toolbarRangeYearToDateAria: '年初来',
    toolbarSeriesTypeCandles: 'キャンドル',
    toolbarSeriesTypeDropdown: 'グラフタイプ',
    toolbarSeriesTypeHighLow: '高低',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: '空洞のろうそく',
    toolbarSeriesTypeLine: 'ライン',
    toolbarSeriesTypeLineWithMarkers: 'マーカー付き折れ線グラフ',
    toolbarSeriesTypeOHLC: 'OHLC(始値、高値、安値、終値)',
    toolbarSeriesTypeStepLine: '階段線',
    toolbarZoomPanEnd: '最後までパン',
    toolbarZoomPanLeft: '左にパン',
    toolbarZoomPanRight: '右にパン',
    toolbarZoomPanStart: '最初にパンする',
    toolbarZoomReset: 'ズームをリセット',
    toolbarZoomZoomIn: 'ズームイン',
    toolbarZoomZoomOut: 'ズームアウト',
    tooltipPaginationStatus: '${index}[number] の ${count}[number]',
};
